import { Component, LOCALE_ID, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GetTokenBindingModel } from 'src/app/api/models/base.model';
import { SendEmailVerificationBindingModel } from 'src/app/api/models/web-booking.models';
import { AppConstants } from 'src/app/app.constants';
import { PasswordDialogComponent } from 'src/app/controls/password-dialog/password-dialog.component';
import { BaseComponent } from 'src/app/layout/main/base.component';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  providers: [
    { provide: LOCALE_ID, useValue: 'en-AU' },
    { provide: MAT_DATE_LOCALE, useValue: 'en-AU' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})
export class ProfileComponent extends BaseComponent implements OnInit {

  form: FormGroup;

  healthFunds: any[];
  states: any[];
  selectedState: any = { suburbs: [] };
  filteredSuburbs: any[] = [];
  countries: any[];
  genders: any[];
  yesNo = [];

  public modalRef: BsModalRef;
  @ViewChild('addressNotesDialog') addressNotesDialog: TemplateRef<any>;

  isAddressHasBeenClicked = false;

  ngOnInit(): void {
    this.app.pageTitle = 'Update your profile';

    // this.form = this.app.formBuilder.group({
    //   email: ['', Validators.required],
    //   firstName: ['', Validators.required],
    //   lastName: ['', Validators.required],
    //   mobilePhoneNumber: ['', Validators.required],
    //   dateOfBirth: [''],
    //   gender: [''],
    //   healthFundId: [''],
    //   isAustralianPhoneNumber: [''],
    //   address1: [''],
    //   address4: [''],
    //   postCode: [''],
    //   stateId: [''],
    //   countryId: [''],
    // });

    this.form = this.app.formBuilder.group({
      email: [''],
      email2: [''],
      firstName: [''],
      lastName: [''],
      mobilePhoneNumber: ['', Validators.required],
      dateOfBirth: [''],
      gender: [''],
      gender1: [''],
      healthFundId: [''],
      isAustralianPhoneNumber: [''],
      address1: [''],
      address4: [''],
      postCode: [''],
      stateId: [''],
      countryId: [''],
    });

    this.genders = [
      { value: 1, viewValue: 'Male' },
      { value: 2, viewValue: 'Female' }
    ];

    this.yesNo = [
      { value: true, viewValue: 'Yes' },
      { value: false, viewValue: 'No' }
    ];

    this.baseTriggerChild.subscribe(event => {
      this.app.spinner.hide();

      this.getHealthFunds();

      this.scrollTo();
    });

    this.start();
  }

  getHealthFunds(): void {
    this.app.spinner.show();
    const model = { branchId: this.app.branch.branchId };
    this.app.webBookingService.GetHealthFunds(model).subscribe(
      data => {
        this.healthFunds = data;
        this.getStates();
      },
      error => {
        this.showErrorMessage(error);
        this.app.spinner.hide();
      }
    );
  }

  getStates(): void {
    this.app.webBookingService.GetStates().subscribe(
      data => {
        this.states = data;
        this.getCountries();
      },
      error => {
        this.showErrorMessage(error);
        this.app.spinner.hide();
      }
    );
  }

  getCountries(): void {
    this.app.webBookingService.GetCountries().subscribe(
      data => {
        this.countries = data;
        this.pacthValue();
        this.app.spinner.hide();
      },
      error => {
        this.showErrorMessage(error);
        this.app.spinner.hide();
      }
    );
  }

  pacthValue() {
    if (this.app.customer.address != null && this.app.customer.address.state != null && this.states != null) {
      for (let a = 0; a < this.states.length; a++) {
        if (this.states[a].stateId == this.app.customer.address.state.stateId) {
          this.selectedState = this.states[a];
        }
      }
    }

    this.form.patchValue({
      firstName: this.app.customer.firstName,
      lastName: this.app.customer.lastName,
      email: this.app.customer.email,
      email2: this.app.customer.email2,
      mobilePhoneNumber: this.app.customer.mobilePhoneNumber,
      dateOfBirth: this.setBirthOfDate(this.app.customer.dateOfBirth),
      healthFundId: this.app.customer.healthFundId,
      gender: this.app.customer.gender,
      address1: this.app.customer.address != null ? this.app.customer.address.address1 : '',
      address4: this.app.customer.address != null ? this.app.customer.address.address4 : '',
      postCode: this.app.customer.address != null ? this.app.customer.address.postCode : '',
      stateId: this.app.customer.address != null && this.app.customer.address.state != null ? this.app.customer.address.state.stateId : '',
      countryId: this.app.customer.address != null && this.app.customer.address.country ? this.app.customer.address.country.countryId : '',
    });
  }

  setBirthOfDate(dateOfBirth: string): Date {
    if (this.app.stringService.isNotEmpty(dateOfBirth)) return this.app.dateService.getNewDate(dateOfBirth);
    return new Date();
  }

  verifyEmailAddress()
  {
    this.app.spinner.show();
    const m = new SendEmailVerificationBindingModel();
    m.email = this.app.customer.email;
    this.app.webBookingService.SendUpdateEmailVerification(m)
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.showInfoMessage('Please check your email to get your email verification code');
          this.app.router.navigate([AppConstants.RouteUpdateEmailAddress]);
        },
        error => {
          this.showErrorMessage(error);
        });
  }

  checkIfEmailIsChanged() {
    // if (this.app.stringService.isEmpty(this.form.value.firstName)) {
    //   this.showErrorMessage('First Name is required.');
    //   return;
    // }
    // if (this.app.stringService.isEmpty(this.form.value.lastName)) {
    //   this.showErrorMessage('Last Name is required.');
    //   return;
    // }
    if (this.app.stringService.isEmpty(this.form.value.email)) {
      this.showErrorMessage('Mobile No. is required.');
      return;
    }
    if (this.app.stringService.isEmpty(this.form.value.mobilePhoneNumber)) {
      this.showErrorMessage('Mobile No. is required.');
      return;
    }
    // if (this.app.stringService.isNotEmpty(this.form.value.dateOfBirth)) {
    //   var date = new Date(this.form.value.dateOfBirth)
    //   this.form.value.dateOfBirth = this.app.dateService.formatDateTime(date);
    // }    
    if (this.app.stringService.isEmpty(this.form.value.mobilePhoneNumber)) {
      this.showErrorMessage('Mobile No. is required.');
      return;
    }
    if (this.app.stringService.isEmpty(this.form.value.address1)) {
      this.showErrorMessage('Address 1 is required.');
      return;
    }
    if (this.app.stringService.isNotValidAddress1(this.form.value.address1)) {
      this.showErrorMessage('PO Box is not allowed.');
      return;
    }
    if (this.app.stringService.isEmpty(this.form.value.stateId)) {
      this.showErrorMessage('State is required.');
      return;
    }
    if (this.app.stringService.isEmpty(this.form.value.address4)) {
      this.showErrorMessage('Suburb is required.');
      return;
    }
    if (this.app.stringService.isEmpty(this.form.value.postCode)) {
      this.showErrorMessage('Postcode is required.');
      return;
    }
    if (this.app.stringService.isEmpty(this.form.value.countryId)) {
      this.showErrorMessage('Country is required.');
      return;
    }

    if (this.app.stringService.isEmpty(this.form.value.sendSms)) this.form.value.sendSms = false;
    if (this.app.stringService.isEmpty(this.form.value.sendEmail)) this.form.value.sendEmail = false;
    if (this.app.stringService.isEmpty(this.form.value.sendPhone)) this.form.value.sendPhone = false;

    var email2 = this.form.value.email;
    if (this.app.customer.email != email2) {
      this.showPasswordDialog();
    }
    else {
      this.updateProfile();
    }
  }

  showPasswordDialog(): void {
    const dialogRef = this.app.dialog.open(PasswordDialogComponent, {
      data: this.app.customer,
    });
    dialogRef.afterClosed().subscribe((result: { action: string; } | null) => {
      if (result != null) {
        if (result.action == '1') {
          this.updateProfile();
        }
      }
    });
  }
  

  updateProfile(): void {
    this.app.spinner.show();
    this.app.webBookingService.UpdateCustomer(this.form.value)
      .subscribe(
        data => {
          if (data.requiredForUpdateEmailVerification) {
            this.showSuccessMessage('Update email verification code has been sent to your current and new email address.');
          }
          else {
            this.showSuccessMessage('Your profile was successfully updated.');
          }
          this.app.spinner.hide();
          this.getProfile();
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  getProfile(): void {
    this.app.webBookingService.GetProfile()
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.customer = data;
          this.app.storageService.setItem(AppConstants.Customer, JSON.stringify(this.app.customer));
          this.back(true);
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  back(isDoubleBack:boolean=false)
  {
    var oldURL = document.referrer;
    var currentUrl = document.location.hostname;
    if(this.app.stringService.isEmpty(oldURL))
    {
      this.app.router.navigate([AppConstants.RouteSelectConsultation]);
    }
    else if(oldURL.includes(currentUrl))
    {
      history.back();
      history.back();
    }
    else{
      this.app.router.navigate([AppConstants.RouteSelectConsultation]);
    }
  }

  get formGroup() { return this.form.controls; }

  formControlErrorMessage(formControl: string, maxlength: number = 11, minlength: number = 6): string {
    if (this.form.controls[formControl].touched) {
      return this.form.controls[formControl].hasError('required') ? 'This is field is required.' :
        this.form.controls[formControl].hasError('email') ? 'Must be a valid email.' :
          this.form.controls[formControl].hasError('minlength') ? 'Minimum length is ' + minlength + '.' :
            this.form.controls[formControl].hasError('maxlength') ? 'Maximum length is ' + maxlength + '.' :
              '';
    }
  }

  showAddressNotification() {
    if (this.isAddressHasBeenClicked) return;
    this.isAddressHasBeenClicked = true;
    this.modalRef = this.app.modalService.show(
      this.addressNotesDialog,
      {
        class: 'modal-dialog-centered modal-dialog-scrollable',
        ignoreBackdropClick: true,
        keyboard: false
      }
    );
  }

  onAddress1Change(e: any) {
    setTimeout(() => {
      const model = this.form.getRawValue();
      if (this.app.stringService.isNotValidAddress1(model.address1)) {
        model.address1 = '';
        this.form.patchValue(model);
        this.showErrorMessage('PO Box is not allowed.');
        this.app.spinner.hide();
        return false;
      }
    }, 100);
  }

  closeDialog(): void {
    this.modalRef.hide();
  }

  onStateOptionClicked(item) {
    this.selectedState = item;
    const data = this.form.getRawValue();
    data.postCode = '';
    data.address4 = '';
    this.form.patchValue(data);
  }

  onSuburbOptionClicked(item) {
    const data = this.form.getRawValue();
    data.postCode = item.postcode;
    this.form.patchValue(data);
  }

  filterSuburb(value: string): void {
    const filterValue = value.toLowerCase();

    if (this.selectedState.suburbs.length > 0) {
      this.filteredSuburbs = this.selectedState.suburbs.filter(suburb => {
        return suburb.name.toLowerCase().indexOf(filterValue) === 0;
      });
    } else {
      this.filteredSuburbs = [];
    }
  }

  sendUpdateEmailVerificationCodeToCurrentEmail(): void {
    this.app.spinner.show();
    this.app.webBookingService.SendUpdateEmailVerificationCodeToCurrentEmail()
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.showSuccessMessage('Your update email verification code successfully sent to your current email address.');
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  sendUpdateEmailVerificationCodeToNewEmail(): void {
    this.app.spinner.show();
    this.app.webBookingService.SendUpdateEmailVerificationCodeToNewEmail()
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.showSuccessMessage('Your update email verification code successfully sent to your new email address.');
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  sendUpdateEmailVerificationCodeToEmail(): void {
    this.app.spinner.show();
    this.app.webBookingService.SendUpdateEmailVerificationCodeToEmail()
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.showSuccessMessage('Your update email verification code successfully sent to your new email address.');
          this.app.router.navigate([AppConstants.RouteUpdateEmailAddress]);
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  cancelUpdateCustomerEmailAddress(): void {
    this.app.spinner.show();
    this.app.webBookingService.CancelUpdateCustomerEmailAddress()
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.getProfile();
          this.showSuccessMessage('Updating email address has been cancelled.');
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  goToUpdateEmailAddress() {    
    this.app.router.navigate([AppConstants.RouteUpdateEmailAddress]);
  }
}
